import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getDocumentFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t('policy.fields.Title'),
      columnHeader: t('policy.columns.title'),
      allowAsConditionSource: true,
    },
    Purpose: {
      fieldId: 'Purpose',
      formLabel: t('policy.fields.Purpose'),
      columnHeader: t('policy.columns.purpose'),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    ParentDocument: {
      fieldId: 'ParentDocument',
      formLabel: t('policy.fields.Parent'),
      columnHeader: t('policy.columns.parent'),
      allowTargetConditions: true,
    },
    DocumentType: {
      fieldId: 'DocumentType',
      formLabel: t('policy.fields.DocumentType'),
      columnHeader: t('policy.columns.type'),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'policy.types',
      },
    },
    linkedDocuments: {
      fieldId: 'linkedDocuments',
      formLabel: t('policy.fields.LinkedDocuments'),
      allowTargetConditions: true,
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t('policy.fields.Owner'),
      columnHeader: t('columns.owners'),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t('fields.Contributor'),
      columnHeader: t('columns.contributors'),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t('fields.Tags'),
      columnHeader: t('columns.tags'),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t('fields.Departments'),
      columnHeader: t('columns.departments'),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
